<template>
  <div class="nav-bar">
    <div class="flex-box align-center nav-left">
      <a-breadcrumb class="title-routes" :routes="routes">
        <template v-slot:itemRender="{route}">
          <span v-if="routes.indexOf(route) === routes.length - 1">{{route.breadcrumbName}}</span>
          <router-link :to="route.path" v-else>{{route.breadcrumbName}}</router-link>
        </template>
      </a-breadcrumb>
    </div>
    <a-space class="nav-user" @click.stop="showMenu" v-if="user">
      <img src="../../assets/avatar.png" class="nav-avatar">
      <div class="user-name">
        <div class="name-txt">{{user.name}}</div>
        <div class="name-auth">{{user.roleText}}</div>
      </div>
      <div class="icon-down"></div>
    </a-space>
    <div class="down-box" v-show="ms">
      <div class="down-box-item" @click.stop="ModifyPassword">
        <a-icon type="edit" />
        <div class="down-txt">修改密码</div>
      </div>
      <div class="down-box-item" @click.stop="logout">
        <a-icon type="logout" />
        <div class="down-txt">退出登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import {cleanToken} from "../../common/js/storage";
import {getRoleTypeText} from "../../common/constant/org";
import entityConfig from "../../common/constant/entity";

export default {
  name: "nav-bar",
  data() {
    return {
      menu: [],
      ms: false,
      routes: [],
      current: [this.$route.path]
    }
  },
  computed: {
    user () {
      let user = this.$store.getters.user;
      if(user) {
        user.roleText = getRoleTypeText(user)
      }
      return user;
    },
    activity() {
        return this.$store.getters.activity;
    }
  },
  watch: {
    $route(val) {
      this.current = [val.path];
      this.setRoutes();
    },
    activity() {
      this.setRoutes();
    }
  },
  created() {
    document.addEventListener('click', this.hideMenu, false);
    this.setRoutes();
    // wxConfig([]);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMenu, false);
  },
  methods: {
    ModifyPassword() {
      this.$router.push({name: 'Password'});
      this.hideMenu();
    },
    logout() {
      cleanToken();
      location.replace( '/login');
    },
    showMenu() {
      this.ms = !this.ms;
    },
    hideMenu() {
      this.ms = false;
    },
    setRoutes() {
      let matched = this.$route.matched;
      let params = this.$route.params;
      let type = params.type;
      let activity = this.activity;
      if(matched.length <= 0) return;
      let routes = [];
      matched.forEach(route => {
        let name = route.name;
        let entity = entityConfig[type];
        switch (name) {
          case 'Home':
            break;
          case 'Entity':
            break;
          case 'List':
            routes.push({
              path: `/entity/${type}`,
              breadcrumbName: entity.listTitle ? entity.listTitle : `${entity.name}管理`
            })
            break;
          case 'AddEntity':
            routes.push({
              path: `/entity/${type}/add`,
              breadcrumbName: `添加${entity.name}`
            })
            break;
          case 'EntityDetail':
            routes.push({
              path: `/entity/${type}/detail/${params.id}`,
              breadcrumbName: `${entity.name}详情`
            })
            break;
          case 'Activity':
            routes.push({
                path: '/activity',
                breadcrumbName: '活动管理'
            })
            if(activity) {
              routes.push({
                path: activity.charge_status == 0 ? `/act/${activity.id}/detail` : `/act/${activity.id}/info`,
                breadcrumbName: activity.name
              })
            }
            break;
          case 'ActivityInfo':
            break;
          case 'ActivityDetail':
            if(activity && activity.charge_status > 0) {
              routes.push({
                path: `/act/${activity.id}/detail`,
                breadcrumbName: route.meta.title
              })
            }
            break;
          default:
            routes.push({
              path: location.pathname,
              breadcrumbName: route.meta.title
            })
            break;
        }
      });
      this.routes = routes;
    },
  }
}
</script>

<style lang="less">
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 0 @padding-md;
  height: 60px;
  background-color: #B5D9EF;
  box-shadow: @box-shadow-base;
  z-index: 10;
  color: #036DB8;
}
.screen-list {
  margin-left: 24px;
  padding-left: 24px;
  line-height: 1;
}
.logo {
  display: flex;
  align-items: center;
  height: 100%;
}
.collapsed-icon {
  font-size: 20px;
  cursor: pointer;
}
.nav-user {
  position: relative;
  padding: 0 8px;
  height: 100%;
  cursor: pointer;
  font-size: 14px;
  .icon-down {
    font-size: 8px;
  }
}
.nav-avatar {
  width: 28px;
  height: 28px;
}
.name-auth {
  font-size: 12px;
}
.user-down {
  margin-left: 4px;
  font-size: 16px;
}
.name-down {
  font-size: 16px;
}
.down-box {
  position: absolute;
  top: 68px;
  right: 24px;
  min-width: 160px;
  border: var(--border);
  background-color: #ffffff;
}
.down-box-item {
  display: flex;
  align-items: center;
  padding: @padding-sm @padding-md;
  cursor: pointer;
  &:hover {
    background-color: @background-color-light;;
  }
}
.down-txt {
  margin-left: 8px;
}
</style>
